import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]更新阅读次数
 */
export function addReadNumUsingPOST(req: UpdateReadNumDto | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.postNoAuth('/LcFixedSchoolController/addReadNum', req, config);
}

/**
 * [No Auth]定投学堂信息列表
 */
export function getFixedSchoolInfoUsingPOST(
  req: LcSchoolInfoQueryDto | void,
  config?: RequestConfig
): Promise<ApiResultLcSchoolInfoVo> {
  return resource.postNoAuth('/LcFixedSchoolController/fixedSchoolInfo', req, config);
}

/**
 * [No Auth]根据id获取详情
 */
export function getInfoByIdUsingPOST(
  req: LcSchoolInfoQueryByIdDto | void,
  config?: RequestConfig
): Promise<ApiResultLcSchoolInfoDto> {
  return resource.postNoAuth('/LcFixedSchoolController/getInfoById', req, config);
}
